<template>
  <button class="btn" type="button">
    <slot />
  </button>
</template>

<script>
export default {
  props: {
    notify: false,
    icon: '',
    redirect: '#',
  },
};
</script>

<style lang="scss">
.btn {
  background: #609;
  border-radius: 50%;
  border: 0;
  padding: 12px 14px;
  width: 40px;
  height: 40px;
  transition: all 0.3s ease-in-out;
  &:hover {
    transform: scale(1.15);
    background: lighten(#609, 10%);
  }

  img {
    height: 13px;
    width: 13px;
  }
}
</style>
